export default {
  hr: {
    menu: {
      profile: "Profile",
      performances: "Performances",
      hiring: "Hiring",
      trainings: "Trainings",
      expenses: "Expenses",
      imprests: "Imprests",
      papers: "Papers",
      documents: "Documents",
      health: "Health",
      debit_tickets: "Debit Tickets",
      payroll: "Payrolls",
      payslip_explanation: "Payslip Explanation",
      events: "Events",
      approvals: "Approval Requests",
      expense_approval: "Expense Requests",
      imprest_approval: "Imprest Requests",
      messages: "Messages",
      inbox: "Inbox",
      outbox: "Outbox",
      suggestions: "Suggestions",
      notes: "Notes",
      travels: "Travels",
      travel_requests: "Travel Requests",
      vehicles: "Vehicles",
      menus: "Food Menu",
      contact: "Contact",
      expense: "Expense",
      expense_request_history: "Expense Request History",
      imprest: "Imprest",
      imprest_request_history: "Imprest Request History",
      travel: "Travel",
      travel_request_history: "Travel Request History",
      debit_ticket_transfer_requests: "Debit Ticket Transfer Requests",
      training: "Training",
      training_requests: "Training Requests",
      training_request_history: "Training Request History",
      survey: "Survey",
      pending_surveys: "Pending Surveys",
      completed_surveys: "Completed Surveys",
      my_team: "My Team"
    },
    account: {
      overview: "Overview",
      email: "E-mail",
      information: "Information",
      language_role: "Language & Role",
      profile: "Profile",
      contact: "Contact",
      personal: "Personal",
      family: "Family",
      education: "Education",
      employment: "Employment",
      financial: "Financial",
      social_media: "Social Media",
      body_size: "Body Size",
      mobile_device: "Mobile Devices",
      special_fields: "Special Fields",
      messages: "Messages",
      notes: "Notes",
      management: "Management"
    },
    employee: {
      overview: {
        staff_number: "Staff Number",
        branch: "Branch",
        unit: "Unit",
        team: "Team",
        email: "E-mail",
        job_info: "Job Info",
        leave: {
          manager: "Time Off Manager",
          managers: "Time Off Managers",
          approver: "Time Off Approver"
        },
        hired_date: "Hired Date",
        status: "Status",
        manager: "Manager",
        shift_manager: "Shift Manager",
        shift_managers: "Shift Managers",
        role: "Role"
      },
      information: {
        identity_number: "Identity Number",
        first_name: "First Name",
        last_name: "Last Name",
        work_email: "Work Email",
        phone: "Phone",
        email_and_sms_send_question: "Send e-mail and sms notification to this employee?"
      },
      profile: {
        identity_number: "Identity Number",
        first_name: "First Name",
        last_name: "Last Name",
        work_email: "Work Email",
        phone: "Phone",
        email_and_sms_send_question: "Send e-mail and sms notification to this employee?",
        service_line: "Service Line"
      },
      language_role: {
        language: "Language",
        role: "Role"
      },
      contact: {
        email: "E-mail",
        address: "Address",
        secondary_phone: "Secondary Phone",
        fixed_phone: "Fixed Phone",
        work_phone: "Work Phone",
        spouse_phone: "Spouse Phone",
        extension_number: "Extension Number",
        emergency_contact_name: "Emergency Contact Name",
        emergency_contact_phone: "Emergency Contact Phone"
      },
      personal: {
        pasaport_number: "Passport Number",
        birth_date: "Birth Date",
        place_of_birth: "Place Of Birth",
        nationality: "Nationality",
        blood_type: "Blood Type",
        gender: "Gender",
        disability_level: "Disability Level",
        ex_convict: "Ex Convict",
        driver: "Driver",
        military_service: "Military service",
        suspended_until: "Suspended Until",
        hes_code: "HES Code",
        hes_expired_date: "HES Code Expired Date"
      },
      family: {
        marital_status: "Marital Status",
        spouse_name: "Spouse Name",
        child_count: "Child Count",
        tenant: "Tenant",
        martyrs_relatives: "Martyr Relatives",
        disability_child_count: "Disability Child Count",
        date_of_marriage: "Date of Marriage",
        father_name: "Father Name",
        mother_name: "Mother Name",
        mothers_maiden_name: "Mother's Maiden Name",
        sibling_count: "Sibling Count",
        child_info: "Child Info",
        add_child_info: "Add Child Info"
      },
      education: {
        graduation: "Graduation",
        school: "School",
        faculty: "Faculty",
        department: "Department",
        graduation_grade: "Graduation Grade",
        academic_title: "Academic Title",
        languages: "Languages",
        licence_file: "Licence File"
      },
      employment: {
        staff_number: "Staff Number",
        branch: "Branch",
        unit: "Unit",
        team: "Team",
        job_info: "Job Info",
        manager: "Manager",
        agency: "Agency",
        ssn: "SSN",
        passive: "Passive",
        hired_date: "Hired Date",
        started_date: "Started Date",
        employment_type: "Employment Type",
        collar_type: "Collar Type",
        quite_job: "End Employment",
        quit_job_reason: "Quit Job Reasons",
        quit_job_reason_description: "Description",
        description: "Description",
        quit_job_date: "Quit Job Date",
        have_an_interview_made: "Interview Made",
        have_an_interview_made_not: "No Interviews Made",
        integration_value: "Integration Number",
        research_and_development_person: "R&D Employee",
        social_security_type: "Social Security Type",
        company: "Company",
        allowance_date: "Allowance Started Date"
      },
      financial: {
        iban: "IBAN",
        ticket_number: "Ticket Number",
        bank_account_number: "Bank Account Number",
        bank_branch: "Bank Branch",
        salary: "Salary",
        ticket_price: "Ticket Price",
        previous_salary: "Previous Salary",
        previous_ticket_price: "Previous Ticket Price",
        yearly_premium: "Yearly Premium",
        monthly_stoppage: "Monthly Stoppage",
        health_insurance_person_count: "Health Insurance Person Count",
        agi: "Minimum Living Allowance",
        gross_salary: "Gross Salary",
        pay_to_net: "Net Salary",
        pay_to_gross: "Gross Salary",
        salary_type: "Salary Payment Type"
      },
      social_media: {
        facebook: "Facebook",
        twitter: "Twitter",
        instagram: "Instagram",
        linkedin: "Linkedin",
        skype: "Skype"
      },
      body_size: {
        weight: "Weight",
        height: "Height",
        shirt_size: "Shirt Size",
        pants_size: "Pants Size",
        shoe_size: "Shoe Size",
        waistcoat: "Waistcoat",
        coat: "Coat"
      },
      management: {
        manager: "Manager",
        leave_managers: "Time Off Managers",
        shift_managers: "Shift Managers",
        overtime_managers: "Overtime Managers",
        expense_managers: "Expense Managers"
      },
      mobile_device: {
        serial_number: "Serial Number",
        multiple_device_allowed: "Multiple Device Allowed"
      }
    },
    performance: {
      results: {
        evaluatee: "Evaluatee",
        published_evaluators: "Published Evaluators",
        unpublished_evaluators: "Unpublished Evaluators",
        kpi_score: "Kpi Score",
        competence_score: "Competence Score",
        totalCount: "Total Participant",
        publishedCount: "Active Participant",
        evaluation_name: "Evaluation Name",
        total_score: "Total Score",
        status: "Status",
        period: "Period",
        scoring: "Scoring",
        beginDate: "Begin Date",
        endDate: "End Date"
      },
      table: {
        name: "Name",
        type: "Performance Type",
        score_range: "Score Range",
        evaluatee: "Employee to be Evaluated",
        expiration_period: "Expiration Period",
        validation_period: "Validation Period",
        status: "Evaluation Status",
        categories: "Categories"
      },
      depths: {
        depth_1: "1. Level",
        depth_2: "2. Level",
        depth_3: "3. Level",
        depth_4: "4. Level",
        depth_5: "5. Level"
      },
      add: {
        kpi: "Add Kpi",
        competence: "Add Competence",
        pool: "I want to add from the pool",
        custom: "I want to add a new",
        kpi_group: "Add Kpi Group",
        competence_group: "Add Competence Group"
      },
      detail: {
        kpi_group: "Kpi Group Detail",
        competence_group: "Competence Group Detail"
      },
      crud: {
        detail: {
          template: "Template Detail",
          evaluation: "Evaluation Plan Detail"
        }
      },
      type: {
        KPI: "Kpi",
        COMPETENCE: "Competence"
      },
      validation: {
        add_item: "You must add questions to the {0} category",
        template_exist_category: "{0} Category has been added",
        template_must_a_category: "There must be at least one category in the performance template",
        question_total_weight_required: "The total weight of the questions must be {0}%",
        question_total_weight: "Total weight of questions {0}%",
        category_not_exist: "No such category exists",
        category_total_weight_equals_in_questions:
          "Since the total weight of the category {0} is {1}%, the total weight of the questions belonging to this category must be {1}%.",
        category_in_question_required: "There must be at least one question in the category {0}",
        question_weight_required: "Enter the weight of {0}"
      },
      information:
        '<p class="body-1 mt-5">' +
        "You can create your kpi and competence list by selecting KPI & COMPETENCE categories." +
        "</p>" +
        '<p class="body-1">' +
        "You can make question-based scoring by entering their weight in the kpi and competence questions defined in the category you selected" +
        "</p>" +
        '<p class="body-1">' +
        "The sum of the questions in the list you added should be equal to the weight you set to KPI or COMPETENCE." +
        "</p>",
      total_evaluatees_count: "Total evaluatees count {0}",
      waiting_evaluates_finish: "{0} people are expected to complete the evaluation",
      complete_evaluation: "This evaluation has been completed",
      expiration_date: "Expiration Date",
      template_name: "Template Name",
      kpi: "Kpi",
      kpi_category: "Kpi Category",
      kpis: "Kpis",
      competence: "Competence",
      competence_category: "Competence Category",
      competences: "Competences",
      result_view: "Show Results",
      waiting: "Waiting",
      hourly: "Hourly",
      weekly: "Weekly",
      monthly: "Monthly",
      yearly: "Yearly",
      score: "Score",
      star: "Star",
      weight: "Weight",
      point: "Point",
      person: "Person",
      persons: "People",
      period_type: "Period",
      score_type: "Score Type",
      score_min_count: "Minimum Score Count",
      score_max_count: "Maximum Score Count",
      evaluation: "Assessment",
      evaluates: "Evaluates",
      evaluators: "Evaluators",
      self: "Self",
      superior: "Superior",
      subordinates: "Subordinates",
      same: "Same",
      flexible: "Flexible",
      period: "Period",
      expiration_dates: "Expiration Date",
      expiration_begin_date: "Expiration Begin Date",
      expiration_end_date: "Expiration End Date",
      level: "Level",
      depth: "Depth",
      validation_date: "Validation Date",
      validation_begin_date: "Validation Begin Date",
      validation_end_date: "Validation End Date",
      published_date_time: "Published Date",
      degree_360: "360 °",
      m2m: "M2M",
      published: "Start Evaluation",
      published_start: "Start Evaluation",
      evaluation_done: "Evaluation Done",
      are_you_sure: "Are you sure?",
      are_you_text: "Do you want to start this assessment?",
      performance_item: {
        title: "Performance"
      },
      my_evaluatees: "My Evaluatees",
      my_evaluated: "My Evaluated"
    },
    training: {
      plan: "Training Plan",
      name: "Training Name",
      type: "Training Type",
      organizer: "Organizer",
      lecturer: "Lecturer",
      terminal: "Terminal",
      sessions: "Sessions",
      session: "Session",
      training_type: {
        ONLINE: "Online",
        CLASSROOM: "Classroom",
        ON_SITE: "On Site"
      },
      training_detail: "Training Detail",
      location: "Location",
      description: "Description",
      training: "Training",
      request_training: "Request a Training",
      training_requests: "Training Requests",
      request_date: "Request Date",
      abolisher: "Abolisher",
      approval_history: "Approval History",
      cancelled_date: "Cancelled Date",
      hr_manager: "HR Manager",
      approval_date: "Approval Date",
      cancel_request: "Cancel Request",
      cancellation_note: "Cancellation note?",
      request_cancellation_process: "Training Request Cancellation Process",
      request_approval_process: "Training Request Approval Process",
      denied: "Deny",
      approved: "Approve",
      training_planned: "Is Training Planned"
    },
    expense: {
      name: "Expense Name",
      type: "Expense Type",
      amount: "Amount",
      date: "Requested Date",
      status: "Status",
      attachment: "Attachment",
      create_expense: "Request An Expense",
      travel: "Travel",
      approved_amount: "Approved Amount"
    },
    imprest: {
      amount: "Amount",
      period: "Imprest Period",
      reason: "Reason",
      status: "Status",
      create_imprest: "Request An Imprest",
      travel: "Travel",
      approved_amount: "Approved Amount",
      date: "Date"
    },
    paper: {
      type: "Paper Type",
      name: "Paper Name",
      issue_date: "Issue Date",
      expire_date: "Expire Date",
      signature_status: "Signature Status",
      signature_types: {
        NOT_REQUIRED: "Not Required",
        STANDARD_SIGNATURE: "Standard Signature",
        BIOMETRIC_SIGNATURE: "Biometric Signature",
        SIGNED: "Signed",
        null: "-",
        E_SIGNATURE: "E-Signature"
      },
      add_paper: "Add Paper",
      papers: {
        issue_date: "Issue Date",
        expire_date: "Expire Date"
      }
    },
    document: {
      name: "Document Name",
      type: "Document Type",
      sender: "Sender",
      date: "Date",
      add_document: "Add Document",
      mobile_accessible_disable: "Mobile accessible disable",
      mobile_accessible_enable: "Mobile accessible enable"
    },
    health: {
      name: "Name",
      category: "Category",
      from: "From Date",
      to: "End Date",
      disease_detail: "Disease Detail",
      importance: "Importance",
      importance_enum: {
        LOW: "Low",
        MEDIUM: "Medium",
        HIGH: "High"
      },
      medicines: "Medicines",
      attachment: "Attachment",
      description: "Description"
    },
    debit_tickets: {
      asset: "Asset",
      borrow_date: "Borrow Date",
      due_date: "Due Date",
      give_back_date: "Give Back Date",
      quantity: "Quantity",
      transfer: "Transfer",
      transfer_approval: "Transfer Approval",
      approver: "Employee To Be Transferred",
      debit_transfer: "Debit Ticket Transfer",
      download_form: "Download Form"
    },
    payroll: {
      month: "Month",
      created_date: "Created Date",
      file: "File"
    },
    events: {
      name: "Name",
      type: "Type",
      owner: "Owner",
      online: "Online",
      begin_date: "Begin Date",
      end_date: "End Date",
      activity: "Activity"
    },
    expense_approval: {
      employee: "Employee",
      description: "Description",
      amount: "Amount",
      status: "Status",
      request_date: "Request Date",
      document: "Document",
      expense_approval: "Expense Approval",
      message:
        "{0} requested an expense amount of <b>{3}</b> in type of <b>{2}</b> on <b>{1}</b>, do you want to approve?"
    },
    imprest_approval: {
      employee: "Employee",
      amount: "Amount",
      status: "Status",
      request_date: "Request Date",
      imprest_approval: "Imprest Approval",
      message: "{0} requested an imprest amount of <b>{2}</b> on <b>{1}</b>, do you want to approve?"
    },
    hiring: {
      job_posting: "Job Posting",
      applicant: "Applicant",
      applicants: "Applicants",
      interview: "Interview",
      assessment_date: "Assessment Date",
      working_date: "Working Date",
      last_job: "Last Job",
      last_position_level: "Last Position Level",
      evaluator: "Evaluator",
      evaluators: "Evaluators",
      weight: "Weight",
      link: "Link",
      skill: "Skill",
      rate: "Rate",
      rating: "Rating",
      table: {
        applicant: "Applicant",
        job_posting: "Job Posting",
        last_job: "Last Job",
        assessment: "Assessment",
        rating: "Rating",
        assessment_date: "Assessment Date",
        status: "Status",
        evaluators: "Evaluators",
        evaluator: "Evaluator"
      },
      skill_type: {
        soft: "Soft",
        technical: "Technical",
        question: "Question",
        link: "Link"
      }
    },
    message: {
      message_type: "Message Type",
      sender: "Sender",
      receivers: "Receivers",
      importance: "Importance",
      title: "Title",
      body: "Body",
      whom: "Whom",
      date: "Date",
      message_type_enum: {
        EMAIL: "E-mail",
        SMS: "Sms",
        IN_APP: "Notification"
      },
      message_importance_enum: {
        LOW: "Low",
        MEDIUM: "Medium",
        HIGH: "High"
      },
      send_message: "Send Message",
      success_message: "{1} sent to {0} person | {1} sent to {0} people"
    },
    suggestion: {
      category: "Suggestion Category",
      title: "Suggestions",
      add_suggestion: "Add Suggestion",
      body: "Message"
    },
    note: {
      notes: "Notes",
      title: "Title",
      body: "Body",
      attachment: "Attachment",
      description: "Description",
      add_note: "Add Note",
      owner: "Employee",
      importance: "Importance"
    },
    travel: {
      request_travel: "Request A Travel",
      leave_request: "Time Off Request",
      travels: "Travels",
      travel: "Travel",
      travel_detail: "Travel Detail",
      start_work_date: "Start Work Date",
      is_domestic: "Is Domestic?",
      country: "Country",
      city: "City",
      region: "Region",
      is_rent_car: "Is Rent Car?",
      is_shuttle: "Is Shuttle?",
      description: "Description",
      reason: "Reason",
      status: "Status",
      expense_message:
        "<strong>{0}</strong> requested to spend <strong>{4}</strong> in <strong>{3}</strong> type called <strong>{2}</strong> on <strong>{1}</strong>",
      imprest_message:
        "<strong>{0}</strong> requested an advance payment of <strong>{2}</strong> on <strong>{1}</strong>",
      subsistence_message:
        "The employee named <strong>{0}</strong> was given a subsistence of <strong>{2}</strong> on <strong>{1}</strong>",
      travel_dates: "Travel Dates",
      pending_travel_approvals: "Pending Travel Approvals",
      travel_process: "Travel Process",
      travel_details: "Travel Details",
      no_detail_item: "No detail item",
      add_new_detail: "Add New Detail",
      detail_type: "Detail Type",
      detail_subtype: "Detail Subtype",
      travel_detail_type_enum: {
        TRANSFER: "Transfer",
        LAYOVER: "Layover",
        BUSINESS: "Business"
      },
      travel_detail_subtype_enum: {
        BUS: "Bus",
        PLANE: "Plane",
        TRAIN: "Train",
        SHIP: "Ship",
        CAR: "Car",
        HOTEL: "Hotel",
        HOSTEL: "Hostel",
        VILLA: "Villa",
        FACTORY: "Factory",
        OFFICE: "Office"
      },
      begin_date: "Begin Date",
      end_date: "End Date",
      expenses: "Expenses",
      imprests: "Imprests",
      debits: "Debits",
      borrow_date: "Borrow Date",
      due_date: "Due Date",
      give_back_date: "Give Back Date",
      quantity: "Quantity",
      name: "Name",
      category: "Category",
      model: "Model",
      subsistences: "Subsistences",
      project: "Project",
      attrition: "Attrition Rate"
    },
    travel_request: {
      employee: "Employee",
      begin_date: "Begin Date",
      end_date: "End Date",
      start_work_date: "Start Work Date",
      status: "Status",
      request_date: "Request Date",
      travel_approval: "Travel Approval",
      message: "<b>{0}</b> requested a travel between <b>{1}</b> - <b>{2}</b>, do you want to approve?"
    },
    vehicle: {
      plate_number: "Plate Number",
      brand: "Brand",
      model: "Model",
      year: "Year",
      branch: "Branch",
      employee: "Employee"
    },
    contact: {
      employee: "Employee",
      email: "E-mail",
      phone: "Phone Number"
    },
    projects: {
      project: "Project",
      employee_count_message: "No employees | 1 employee | {count} employees"
    },
    debit_ticket_transfer_request: {
      requester: "Requester",
      asset: "Asset",
      approval_message:
        "<strong>{0}</strong> has requested to transfer the asset which has the following information to your embezzlement, do you want to confirm?"
    },
    survey: {
      name: "Survey Name",
      published_date: "Publish Date",
      end_date: "End Date",
      start_survey: "Start Survey",
      survey_privacy: "Survey Privacy",
      status: "Status",
      pending_title: "Surveys You Should Complete",
      completed_title: "Surveys I Participated",
      complete_survey: "Complete Survey",
      survey_information: "Survey Information",
      exit: "Exit",
      save_and_finish: "Save And Finish",
      status_enum: {
        completed: "Completed",
        continuous: "Continuous"
      },
      section_count: "Section Count",
      question_count: "Question Count",
      estimated_duration: "Estimated Duration",
      description: "Description",
      anonymous_on: "Closed Voting",
      anonymous_off: "Open Voting",
      enter_answer: "You can enter an answer",
      your_answer: "Your answer",
      please_select: "please select"
    },
    employees: {
      employee_profile: "Employee Profile",
      staffNumber: "Staff Number",
      email: "Email",
      branch: "Branch",
      unit: "Unit",
      team: "Team",
      jobInfo: "Job Ibfo",
      status: "Status",
      hiredDate: "Hired Date",
      birthDate: "Birth Date",
      manager: "Manager",
      hrManagers: "HR Managers",
      leaveManagers: "Time Off Managers",
      shiftManagers: "Shift Managers",
      overtimeManagers: "Overtime Managers",
      leaveAccruals: "Time Off Accruals",
      active: "Active",
      passive: "Passive",
      leaveType: "Time Off Name",
      accrualCount: "Time Off Accrual",
      leaveBalance: "Time Off Balance",
      used: "Used",
      previousBalance: "Previous Balance"
    }
  }
};
